export default __webpack_public_path__ + "static/media/multiple-choice-chess-2.227a52c6.webp";